import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Header } from "./components/Header";
import { useParams } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import { NavLink } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Navbar from "./components/Navbar";
const API_URL = "/api";

export default function CompanyScore() {
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [REVENUE, SetREVENUE] = useState(null);
  const [auditorOptionYear, SetAuditorOptionYear] = useState(null);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [businessScore, setBusinessScore] = useState([]);
  const [financialScore, setFinancialScore] = useState([]);
  const [latestRevenueValue, setLatestRevenueValue] = useState(null);
  const [latestRevenueValueGrowth, SetLatestRevenueValue] = useState(null);
  const [avgThreeYearGPM, setAvgThreeYearGPM] = useState(null);
  const [latestCurrentRatio, SetLatestCurrentRatio] = useState(null);
  const [latestQuickRatio, SetLatestQuickRatio] = useState(null);
  const [latestCashConversionCycle, setCashConversionCycle] = useState(null);
  const [latestCashFlow, setCashFlow] = useState(null);
  const [latestQualityAssets, setQualityAssets] = useState(null);
  const [latestDebtAssetsRatio, setDebtAssetsRatio] = useState(null);
  const [latestNetLeverageRatio, setNetLeverageRatio] = useState(null);
  const [latestInterestCoverageRatio, setInterestCoverageRatio] =
    useState(null);
  const [selectedDB, setSelectedDB] = useState(null);
  const [selectedScore, setSelectedScore] = useState("");
  const [inputValue, setInputValue] = useState("");

  // State for fetched options
  const [cofaceOptions, setCofaceOptions] = useState([]);
  const [selectedCoface, setSelectedCoface] = useState("");
  const [selectedScoreCoface, setSelectedScoreCoface] = useState("");

  // State for SP
  const [spOptions, setSpOptions] = useState([]);
  const [selectedSP, setSelectedSP] = useState("");
  const [selectedScoreSP, setSelectedScoreSP] = useState("");

  // State for Fitch
  const [fitchOptions, setFitchOptions] = useState([]);
  const [selectedFitch, setSelectedFitch] = useState("");
  const [selectedScoreFitch, setSelectedScoreFitch] = useState("");

  // State for Moody
  const [moodyOptions, setMoodyOptions] = useState([]);
  const [selectedMoody, setSelectedMoody] = useState("");
  const [selectedScoreMoody, setSelectedScoreMoody] = useState("");

  // materialLitigation
  const [optionsLitigation, setOptionsLitigation] = useState({});
  const [selectedOptionLitigation, setSelectedOptionLitigation] = useState("");

  // Winding_Up_Petitions
  const [optionsWinding, setOptionsWinding] = useState({});
  const [selectedOptionWinding, setSelectedOptionWinding] = useState("");

  // default rating
  const [selectedDefault, setSelectedDefault] = useState("");

  // Parent rating
  const [selectedParent, setSelectedParent] = useState("");

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getComapnyProfile/${id}`);
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setCompany(data);
        console.log("data", data);
        setCompanyName(data?.COMPANYINFO?.COMPANYNAME_ENGLISH);
        SetREVENUE(data?.FINANCIALANALYSIS?.INCOMESTATEMENT?.REVENUE);
        SetAuditorOptionYear(
          data?.FINANCIALANALYSIS?.Auditor_Option?.AUDITOROPINION
        );
        setFormData(data);
        setBusinessScore(data?.COMPANYSCORE?.BusinessScore || []);
        setFinancialScore(data?.COMPANYSCORE?.FinancialScore || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyDetails();
  }, [id]);

  useEffect(() => {
    const fetchCoface = async () => {
      try {
        const response = await fetch(
          `${API_URL}/getAllRatingTable?type=Coface`
        );
        if (!response.ok) throw new Error("Failed to fetch Coface list");
        const data = await response.json();
        setCofaceOptions(data); // <-- store the array here
      } catch (err) {
        console.error(err);
      }
    };

    fetchCoface();
  }, []);

  useEffect(() => {
    const fetchSP = async () => {
      try {
        const response = await fetch(`${API_URL}/getAllRatingTable?type=SP`);
        if (!response.ok) throw new Error("Failed to fetch SP list");
        const data = await response.json();
        setSpOptions(data);
        console.log("SP:", data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSP();
  }, []);

  useEffect(() => {
    const fetchFitch = async () => {
      try {
        const response = await fetch(`${API_URL}/getAllRatingTable?type=Fitch`);
        if (!response.ok) throw new Error("Failed to fetch Fitch list");
        const data = await response.json();
        setFitchOptions(data);
        console.log("Fitch:", data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchFitch();
  }, []);

  useEffect(() => {
    const fetchMoody = async () => {
      try {
        const response = await fetch(`${API_URL}/getAllRatingTable?type=Moody`);
        if (!response.ok) throw new Error("Failed to fetch Moody list");
        const data = await response.json();
        setMoodyOptions(data);
        console.log("Moody:", data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMoody();
  }, []);

  useEffect(() => {
    const fetchMoody = async () => {
      try {
        const response = await fetch(`${API_URL}/getLitigationRatingTable`);
        if (!response.ok) throw new Error("Failed to fetch Litigation list");
        const data = await response.json();
        console.log("Litigation:", data);
        setOptionsLitigation(data?.Material_Litigation);
        setOptionsWinding(data?.Winding_Up_Petitions);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMoody();
  }, []);

  useEffect(() => {
    const fetchAllRatingTable = async () => {
      try {
        const response = await fetch(`${API_URL}/getAllRatingTable?type=DB`);
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        console.log("Okay");
        console.log("Rating data:", data);
        setSelectedDB(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAllRatingTable();
    // calculate the latest revenue value
    if (REVENUE) {
      const latestYearWithRevenue = Object.keys(REVENUE)
        .sort((a, b) => b - a) // sort years descending
        .find((year) => REVENUE[year] !== null); // pick first year that has revenue
      setLatestRevenueValue(REVENUE[latestYearWithRevenue]);
    }

    // Revenue Growth (2-Year CAGR)
    const getLatestTwoYears = (yearLabels) => {
      if (!yearLabels || typeof yearLabels !== "object") return [];

      return Object.keys(yearLabels)
        .map((y) => parseInt(y, 10)) // ensure numbers
        .filter((y) => !isNaN(y)) // skip invalid keys
        .sort((a, b) => b - a) // latest first
        .slice(0, 2); // take top 2
    };

    // Get latest year
    const getLatestYears = (auditorOptionYear) => {
      if (!auditorOptionYear || typeof auditorOptionYear !== "object") {
        return [];
      }
      return Object.entries(auditorOptionYear)
        .filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
        .map(([year]) => Number(year))
        .sort((a, b) => b - a) // latest first
        .slice(0, 1);
    };

    console.log("getLatestYears", getLatestYears(auditorOptionYear));

    // Logic to calculate Revenue Growth (2-Year CAGR)
    const computeSquareRootRevenueGrowth = (year) => {
      const prevYear = year - 2;
      const currentRevenue =
        company?.FINANCIALANALYSIS?.INCOMESTATEMENT?.REVENUE?.[year] ?? 0;
      const baseRevenue =
        company?.FINANCIALANALYSIS?.INCOMESTATEMENT?.REVENUE?.[prevYear] ?? 0;

      if (baseRevenue === 0 || currentRevenue === 0) return 0;

      const result = Math.sqrt(currentRevenue / baseRevenue) - 1;
      return result * 100; // keep it as number
    };

    const computeCombinedGrowth = (yearLabels) => {
      const latestTwoYears = getLatestTwoYears(yearLabels);

      if (latestTwoYears.length === 0) return "0.00";

      const totalGrowth = latestTwoYears.reduce(
        (sum, year) => sum + computeSquareRootRevenueGrowth(year),
        0
      );

      return totalGrowth.toFixed(2);
    };
    SetLatestRevenueValue(computeCombinedGrowth);

    // Logic to calculate current ratio
    const computeTotalCurrentAssets = (year) => {
      return currentAssetsCategories.reduce((total, cat) => {
        return (
          total +
          (formData?.FINANCIALANALYSIS?.BALANCESHEET?.[cat.key]?.[year] ?? 0)
        );
      }, 0);
    };

    const currentAssetsCategories = [
      { key: "TRADERECEIVABLES", label: "Trade receivables" },
      { key: "RETENTIONRECEIVABLES", label: "Retention receivables" },
      {
        key: "GROSSAMOUNTSDUEFROMCUSTOMERFORCONTRACTWORKS",
        label: "Gross amounts due from customer for contract works",
      },
      { key: "INVENTORIES", label: "Inventories" },
      {
        key: "DEPOSITSPREPAYMENTSANDOTHERRECEIVABLES",
        label: "Deposits, prepayments and other receivables",
      },
      { key: "DUEFROMDIRECTORS", label: "Due from directors" },
      { key: "DUEFROMRELATEDCOMPANIES", label: "Due from related companies" },
      { key: "DUEFROMSHAREHOLDERS", label: "Due from shareholders" },
      { key: "INVESTMENTINQUOTEDSHARES", label: "Investment in quoted shares" },
      { key: "CASHANDBANKBALANCES", label: "Cash and bank balances" },
      { key: "OTHERCURRENTASSETS", label: "Other current assets" },
      { key: "CURRENTTAXRECOVERABLE", label: "Current tax recoverable" },
    ];

    const currentLiabilitiesCategories = [
      { key: "TRADEPAYABLES_CURRENT", label: "Trade payables" },
      {
        key: "GROSSAMOUNTSDUETOCUSTOMERSFORCONTRACTWORKS_CURRENT",
        label: "Gross amounts due to customers for contract works",
      },
      {
        key: "OTHERPAYABLESANDACCRUALS_CURRENT",
        label: "Other payables and accruals",
      },
      { key: "DUETODIRECTORS_CURRENT", label: "Due to directors" },
      {
        key: "DUETORELATEDCOMPANIES_CURRENT",
        label: "Due to related companies",
      },
      { key: "DUETOSHAREHOLDERS_CURRENT", label: "Due to shareholders" },
      {
        key: "OBLIGATIONUNDERFINANCELEASES_CURRENT",
        label: "Obligation under finance leases",
      },
      { key: "BANKOVERDRAFT_CURRENT", label: "Bank overdraft" },

      { key: "BANKBORROWINGS_CURRENT", label: "Bank borrowings" },
      {
        key: "OTHERCURRENTLIABILITIES_CURRENT",
        label: "Other current liabilities",
      },
      {
        key: "CURRENTTAXLIABILITIES_CURRENT",
        label: "Current tax liabilities",
      },
    ];

    const computeTotalCurrentLiabilities = (year) => {
      return currentLiabilitiesCategories.reduce((total, cat) => {
        const rawKey = cat.key.replace("_CURRENT", "");
        const value =
          formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.[rawKey]?.[year] ??
          0;
        return total + value;
      }, 0);
    };

    const CurrentRatio = (year) => {
      const currentAssets = computeTotalCurrentAssets(year);

      const directors =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMDIRECTORS?.[year] ??
        0;

      const companies =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMRELATEDCOMPANIES?.[
          year
        ] ?? 0;

      const shareholders =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMSHAREHOLDERS?.[
          year
        ] ?? 0;

      const CurrentLiabilities = computeTotalCurrentLiabilities(year);

      const directorsTo =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.DUETODIRECTORS?.[
          year
        ] ?? 0;

      const companiesTo =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES
          ?.DUETORELATEDCOMPANIES?.[year] ?? 0;

      const shareholdersTo =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.DUETOSHAREHOLDERS?.[
          year
        ] ?? 0;

      const sum = directors + companies + shareholders;

      const sumTo = directorsTo + companiesTo + shareholdersTo;
      const firstdivide = currentAssets - sum;
      const seconddivide = CurrentLiabilities - sumTo;

      const isValid =
        !isNaN(firstdivide) && !isNaN(seconddivide) && seconddivide !== 0;

      const result = isValid
        ? (firstdivide / seconddivide).toFixed(2)
        : "00.00";

      return result;
    };

    SetLatestCurrentRatio(CurrentRatio(getLatestYears(auditorOptionYear)));

    // Logic to calculate Quick Ratio
    const QuickRatio = (year) => {
      const cash =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.CASHANDBANKBALANCES?.[
          year
        ] ?? 0;

      const tax =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.CURRENTTAXRECOVERABLE?.[
          year
        ] ?? 0;

      const trade =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.TRADERECEIVABLES?.[year] ??
        0;

      const firstSum = cash + tax + trade;

      const TotalCurrentLiabilities = computeTotalCurrentLiabilities(year);

      const directorsTo =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.DUETODIRECTORS?.[
          year
        ] ?? 0;

      const companiesTo =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES
          ?.DUETORELATEDCOMPANIES?.[year] ?? 0;

      const shareholdersTo =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.DUETOSHAREHOLDERS?.[
          year
        ] ?? 0;

      const secondSum = directorsTo + companiesTo + shareholdersTo;

      const final = TotalCurrentLiabilities - secondSum;
      const isValid = !isNaN(firstSum) && final !== 0;

      const result = isValid ? (firstSum / final).toFixed(2) : "00.00";

      return result;
    };
    SetLatestQuickRatio(QuickRatio(getLatestYears(auditorOptionYear)));

    //Gross Profit (3-Year Average)
    // get the latest three years which have value
    const getLatestThreeYears = (auditorOptionYear) => {
      if (!auditorOptionYear || typeof auditorOptionYear !== "object") {
        return [];
      }
      return Object.entries(auditorOptionYear)
        .filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
        .map(([year]) => Number(year))
        .sort((a, b) => b - a) // latest first
        .slice(0, 3);
    };

    const computeGrossProfit = (year) => {
      const revenue =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.REVENUE?.[year] ?? 0;
      const cost =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.LESSCOSTOFSALES?.[year] ??
        0;
      return revenue + cost;
    };

    const GrossProfitMargin = (year) => {
      const gross = computeGrossProfit(year);
      const revenue =
        company?.FINANCIALANALYSIS?.INCOMESTATEMENT?.REVENUE?.[year] ?? 0; // ✅ use company consistently

      if (revenue === 0) return 0;

      const result = (gross / revenue) * 100;
      return result; // return number for averaging
    };

    // average of latest three years
    const getAverageGrossProfitMargin = (auditorOptionYear) => {
      const latestThreeYears = getLatestThreeYears(auditorOptionYear);
      console.log("latestThreeYears...", latestThreeYears);
      if (!latestThreeYears.length) return "0.00";

      const margins = latestThreeYears.map((year) => GrossProfitMargin(year));
      const sum = margins.reduce((acc, val) => acc + val, 0);
      const avg = sum / margins.length;

      return avg.toFixed(2);
    };

    setAvgThreeYearGPM(getAverageGrossProfitMargin(auditorOptionYear));

    //Cash conversion Cycle
    const DaysInventoryOutstanding = (year) => {
      const inventories =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.INVENTORIES?.[year] ?? 0;

      const constOfSales =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.LESSCOSTOFSALES?.[year] ??
        0;

      const isValid = !isNaN(inventories) && constOfSales !== 0;
      const result = isValid
        ? ((inventories / -constOfSales) * 365).toFixed(2)
        : "0";

      return result;
    };

    const DaysSalesOutstanding = (year) => {
      const traderv =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.TRADERECEIVABLES?.[year] ??
        0;

      const retention =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.RETENTIONRECEIVABLES?.[
          year
        ] ?? 0;

      const revenue =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.REVENUE?.[year] ?? 0;

      const sum = traderv + retention;

      const isValid = !isNaN(sum) && revenue !== 0;

      const result = isValid ? ((sum / revenue) * 365).toFixed(2) : 0;

      return result;
    };

    const DaysPayableOutstanding = (year) => {
      const tradepay =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.TRADEPAYABLES?.[
          year
        ] ?? 0;

      const constOfSales =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.LESSCOSTOFSALES?.[year] ??
        0;

      const isValid = !isNaN(tradepay) && constOfSales !== 0;

      const result = isValid
        ? ((tradepay / -constOfSales) * 365).toFixed(2)
        : 0;

      return result;
    };
    const CashConversionCycle = (year) => {
      const InventoryOutstanding = parseFloat(DaysInventoryOutstanding(year));
      const SalesOutstanding = parseFloat(DaysSalesOutstanding(year));
      const PayableOutstanding = parseFloat(DaysPayableOutstanding(year));

      if (
        isNaN(InventoryOutstanding) ||
        isNaN(SalesOutstanding) ||
        isNaN(PayableOutstanding)
      ) {
        return "0.00";
      }

      const result =
        InventoryOutstanding + SalesOutstanding - PayableOutstanding;

      return result.toFixed(2);
    };
    setCashConversionCycle(
      CashConversionCycle(getLatestYears(auditorOptionYear))
    );

    // Logic Cash Flow
    const computeEBITDA = (year) => {
      const grossProfit = computeGrossProfit(year);
      const sga =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.SGANDAEXPENSES?.[year] ??
        0;
      const externalCosts =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.EXTERNALOPERATINGCOSTS_INCLDISTRIBUTIONRANDDSERVICES?.[year] ?? 0;
      const otherTaxes =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.TAXESOTHERTHANINCOMETAX?.[
          year
        ] ?? 0;
      return grossProfit + sga + externalCosts + otherTaxes;
    };
    const computeProfitBeforeTax = (year) => {
      const ebitda = computeEBITDA(year);
      const danda =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.DANDA?.[year] ?? 0;
      const provisions =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.PROVISIONSANDIMPAIRMENTLOSSES?.[year] ?? 0;
      const disposalsPPE =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.DISPOSALSOFPPE_GAINSORLOSSES?.[year] ?? 0;
      const disposalsIntangibles =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.DISPOSALSOFINTANGIBLESSUBSIDIARIESANDAFFILIATES_GAINSORLOSSES?.[
          year
        ] ?? 0;
      const gainsECL =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.GAINSOR_LOSSESRELATEDTOECLCREDITMODEL?.[year] ?? 0;
      const otherIncome =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.OTHERNON_RECURRINGINCOMEOREXPENSES?.[year] ?? 0;
      const financeCosts =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.FINANCECOSTS?.[year] ?? 0;
      return (
        ebitda +
        danda +
        provisions +
        disposalsPPE +
        disposalsIntangibles +
        gainsECL +
        otherIncome +
        financeCosts
      );
    };
    const computeNegativeED = (year) => {
      const ed =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.GAINSOR_LOSSESRELATEDTOECLCREDITMODEL?.[year] ?? 0;
      return -ed;
    };
    const computeNegativeRDI = (year) => {
      const rdi =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.DISPOSALSOFINTANGIBLESSUBSIDIARIESANDAFFILIATES_GAINSORLOSSES?.[
          year
        ] ?? 0;
      return -rdi;
    };
    const computeNegativeGLI = (year) => {
      const gli =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT
          ?.DISPOSALSOFPPE_GAINSORLOSSES?.[year] ?? 0;
      return -gli;
    };
    const computeNegativeFC = (year) => {
      const fc =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.FINANCECOSTS?.[year] ?? 0;
      return -fc;
    };
    const computeNegativeDA = (year) => {
      const da = formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.DA?.[year] ?? 0;
      return -da;
    };
    const computeProfitForYear = (year) => {
      const profitBeforeTax = computeProfitBeforeTax(year);
      const tax =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.INCOMETAXEXPENSE?.[
          year
        ] ?? 0;
      return profitBeforeTax + tax;
    };
    const computeChangesInCL = (year) => {
      const prevYear = year - 1;
      const keys = [
        "TRADEPAYABLES",
        "GROSSAMOUNTSDUETOCUSTOMERSFORCONTRACTWORKS",
        "OTHERPAYABLESANDACCRUALS",
      ];
      const currentSum = keys.reduce((sum, key) => {
        return (
          sum +
          (formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.[key]?.[year] ?? 0)
        );
      }, 0);
      const prevSum = keys.reduce((sum, key) => {
        return (
          sum +
          (formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.[key]?.[prevYear] ??
            0)
        );
      }, 0);
      return currentSum - prevSum;
    };
    const computeChangesInAR = (year) => {
      const prevYear = year - 1;
      const keys = [
        "TRADERECEIVABLES",
        "RETENTIONRECEIVABLES",
        "GROSSAMOUNTSDUEFROMCUSTOMERFORCONTRACTWORKS",
        "INVENTORIES",
        "DEPOSITSPREPAYMENTSANDOTHERRECEIVABLES",
      ];
      const currentSum = keys.reduce((sum, key) => {
        return (
          sum + (formData?.FINANCIALANALYSIS?.BALANCESHEET?.[key]?.[year] ?? 0)
        );
      }, 0);
      const prevSum = keys.reduce((sum, key) => {
        return (
          sum +
          (formData?.FINANCIALANALYSIS?.BALANCESHEET?.[key]?.[prevYear] ?? 0)
        );
      }, 0);
      return prevSum - currentSum;
    };
    const computeCashflowBeforeExchange = (year) => {
      return (
        computeProfitForYear(year) +
        computeNegativeDA(year) +
        computeNegativeFC(year) +
        computeNegativeGLI(year) +
        computeNegativeRDI(year) +
        computeNegativeED(year)
      );
    };
    const computeARandAP = (year) => {
      return (
        computeCashflowBeforeExchange(year) +
        computeChangesInAR(year) +
        computeChangesInCL(year)
      );
    };

    setCashFlow(computeARandAP(getLatestYears(auditorOptionYear)));
    //logic Quality Assets

    const CurrentAssetsfromRelatedParties = (year) => {
      const directors =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMDIRECTORS?.[year] ??
        0;

      const companies =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMRELATEDCOMPANIES?.[
          year
        ] ?? 0;

      const shareholders =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMSHAREHOLDERS?.[
          year
        ] ?? 0;

      const sum = directors + companies + shareholders;

      const TotalCurrentAssets = computeTotalCurrentAssets(year);

      const result = sum / TotalCurrentAssets;
      const isValid = !isNaN(sum) && TotalCurrentAssets !== 0;

      return isValid ? (result * 100).toFixed(2) : "00.00";
    };
    setQualityAssets(
      CurrentAssetsfromRelatedParties(getLatestYears(auditorOptionYear))
    );

    //Logic Debt Assets Ratio
    const computeTotalNonCurrentAssets = (year) => {
      const categories = [
        "PROPERTYPLANTANDEQUIPMENT",
        "RIGHT_OF_USEASSETS",
        "INVESTMENTPROPERTIES",
        "INVESTMENTSOREQUITYAFFILIATES",
        "OTHERNON_CURRENTASSETS_INCLPROVISIONSETC",
      ];
      return categories.reduce((total, cat) => {
        return (
          total +
          (formData?.FINANCIALANALYSIS?.BALANCESHEET?.[cat]?.[year] ?? 0)
        );
      }, 0);
    };
    const DebtAssetsRatio = (year) => {
      const obligation =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES
          ?.OBLIGATIONUNDERFINANCELEASES?.[year] ?? 0;

      const bankOverDraft =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.BANKOVERDRAFT?.[
          year
        ] ?? 0;

      const bankBorrowing =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.BANKBORROWINGS?.[
          year
        ] ?? 0;

      const obligationNon =
        formData?.FINANCIALANALYSIS?.NONCURRENTLIABILITIES
          ?.OBLIGATIONUNDERFINANCELEASES?.[year] ?? 0;

      const bankBorrowingNon =
        formData?.FINANCIALANALYSIS?.NONCURRENTLIABILITIES?.BANKBORROWINGS?.[
          year
        ] ?? 0;

      const sum =
        obligation +
        bankOverDraft +
        bankBorrowing +
        obligationNon +
        bankBorrowingNon;

      const TotalCurrentAssets = computeTotalCurrentAssets(year);
      const TotalNonCurrentAssets = computeTotalNonCurrentAssets(year);
      const directors =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMDIRECTORS?.[year] ??
        0;

      const companies =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMRELATEDCOMPANIES?.[
          year
        ] ?? 0;

      const shareholders =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.DUEFROMSHAREHOLDERS?.[
          year
        ] ?? 0;

      const sum2 =
        TotalCurrentAssets +
        TotalNonCurrentAssets -
        (directors + companies + shareholders);

      const isValid = !isNaN(sum) && sum2 !== 0;

      const result = isValid ? (sum / sum2).toFixed(2) : "00.00";

      return result;

      // return (result * 100).toFixed(2) + "%";
    };
    setDebtAssetsRatio(DebtAssetsRatio(getLatestYears(auditorOptionYear)));
    //logic net leverage Ratio
    const NetDebtEBITDARatio = (year) => {
      const obligation =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES
          ?.OBLIGATIONUNDERFINANCELEASES?.[year] ?? 0;

      const bankOverDraft =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.BANKOVERDRAFT?.[
          year
        ] ?? 0;

      const bankBorrowing =
        formData?.FINANCIALANALYSIS?.CURRENTLIABILITIES?.BANKBORROWINGS?.[
          year
        ] ?? 0;

      const obligationNon =
        formData?.FINANCIALANALYSIS?.NONCURRENTLIABILITIES
          ?.OBLIGATIONUNDERFINANCELEASES?.[year] ?? 0;

      const bankBorrowingNon =
        formData?.FINANCIALANALYSIS?.NONCURRENTLIABILITIES?.BANKBORROWINGS?.[
          year
        ] ?? 0;

      const cash =
        formData?.FINANCIALANALYSIS?.BALANCESHEET?.CASHANDBANKBALANCES?.[
          year
        ] ?? 0;

      const EBITDA = computeEBITDA(year);

      const sum =
        obligation +
        bankOverDraft +
        bankBorrowing +
        obligationNon +
        bankBorrowingNon -
        cash;

      const isValid = !isNaN(sum) && EBITDA !== 0;

      const result = isValid ? (sum / EBITDA).toFixed(2) : "00.00";

      return result;

      // return (result * 100).toFixed(2) + "%";
    };
    setNetLeverageRatio(NetDebtEBITDARatio(getLatestYears(auditorOptionYear)));

    // Logic Interest Coverage Ratio
    const InterestCoverageRatio = (year) => {
      const EBITDA = computeEBITDA(year);

      const financeCost =
        formData?.FINANCIALANALYSIS?.INCOMESTATEMENT?.FINANCECOSTS?.[year] ?? 0;

      const isValid = !isNaN(EBITDA) && financeCost !== 0;

      const result = isValid ? (EBITDA / -financeCost).toFixed(2) : "00.00";

      return result;
    };
    setInterestCoverageRatio(
      InterestCoverageRatio(getLatestYears(auditorOptionYear))
    );
    if (companyName) {
      document.title = companyName;
    } else {
      document.title = "Company Log";
    }

    return () => {
      document.title = "Company Log";
    };
  }, [REVENUE, companyName, financialScore]);

  const handleInputChange = (scoreType, index, field, value) => {
    const updated = [
      ...(scoreType === "business" ? businessScore : financialScore),
    ];
    updated[index][field] = value;

    if (scoreType === "business") {
      const metric = updated[index].METRIC?.trim().toLowerCase();

      if (field === "INPUT") {
        if (metric === "country risk") {
          switch (value) {
            case "A":
              updated[index].SCORE = 5;
              break;
            case "B":
              updated[index].SCORE = 0;
              break;
            case "C":
              updated[index].SCORE = -5;
              break;
            case "D":
              updated[index].SCORE = 10;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "industry risk") {
          switch (value) {
            case "Low cyclicality, moderate competitive risk":
              updated[index].SCORE = 0;
              break;
            case "Intermediate cyclicality, medium competitive risk":
              updated[index].SCORE = -2;
              break;
            case "High cyclicality, high competitive risk":
              updated[index].SCORE = -5;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "years in operation") {
          switch (value) {
            case "less than 3 years":
              updated[index].SCORE = -2;
              break;
            case "3 years to 7 years":
              updated[index].SCORE = 3;
              break;
            case "more than 7 years":
              updated[index].SCORE = 5;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "industry reputation / project track record") {
          switch (value) {
            case "Positive industry reputation for standard of execution (for example ability to work on public works, HH subcon, etc.)":
              updated[index].SCORE = 10;
              break;
            case "No information available from industry sources and advisors":
              updated[index].SCORE = 0;
              break;
            case "Negative industry reputation for standard of execution":
              updated[index].SCORE = -10;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "customer / project concentration") {
          switch (value) {
            case "Multiple ongoing projects (3 or more projects)":
              updated[index].SCORE = 10;
              break;
            case "Few ongoing projects":
              updated[index].SCORE = 5;
              break;
            case "No projects":
              updated[index].SCORE = -10;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "winding-up petitions") {
          switch (value) {
            case "No winding-up petitions":
              updated[index].SCORE = 0;
              break;
            case "Winding-up petitions that have been withdrawn (Past 3 years)":
              updated[index].SCORE = -10;
              break;
            case "Existing unsettled winding-up petition":
              updated[index].SCORE = -30;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "material litigation") {
          switch (value) {
            case "No material litigation":
              updated[index].SCORE = 0;
              break;
            case "Material litigation that has been settled (Past 3 years)":
              updated[index].SCORE = -5;
              break;
            case "Existing material litigation":
              updated[index].SCORE = -15;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "ownership") {
          switch (value) {
            case "Resourced (i.e. part of a large parent or listed organization can access funding if needed)":
              updated[index].SCORE = 5;
              break;
            case "Under-resourced (i.e.no option for support or support unlikely)":
              updated[index].SCORE = 0;
              break;
            case "Distressed (i.e. owner is in financial difficulty, likely to borrow from the company)":
              updated[index].SCORE = -10;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "management ability") {
          switch (value) {
            case "Executive team with considerable industry experience":
              updated[index].SCORE = 5;
              break;
            case "Executive team with little industry experience":
              updated[index].SCORE = 1;
              break;
            case "Sole founder/owner with considerable industry experience":
              updated[index].SCORE = 4;
              break;
            case "Sole founder/owner with little industry experience":
              updated[index].SCORE = 0;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "administrative capacity") {
          switch (value) {
            case "Medium (meets expectations)":
              updated[index].SCORE = 3;
              break;
            case "High (displaying quick, accurate, and organized communication and reporting)":
              updated[index].SCORE = 5;
              break;
            case "Low (know instances of missing or inaccurate processes/information)":
              updated[index].SCORE = 0;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }

        if (metric === "repayment track record of riverchain's loans") {
          switch (value) {
            case "Timely":
              updated[index].SCORE = 0;
              break;
            case "N/A":
              updated[index].SCORE = 0;
              break;
            case "Slight delay (< 3 business days from maturity date)":
              updated[index].SCORE = -5;
              break;
            case "Significant delay (> 3 business days from maturity date)":
              updated[index].SCORE = -15;
              break;
            default:
              updated[index].SCORE = 0;
          }
        }
      }
    }

    scoreType === "business"
      ? setBusinessScore(updated)
      : setFinancialScore(updated);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const payload = {
        COMPANYID: company.COMPANYID,
        update_data: formData,
      };

      const response = await fetch(
        `${API_URL}/updateCompanyProfile?username=pritomrajkhowa`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error("Failed to update company profile");

      const result = await response.json();
      toast.success("Company score updated successfully");

      const updatedResponse = await fetch(`${API_URL}/getComapnyProfile/${id}`);
      const updatedData = await updatedResponse.json();
      setCompany(updatedData);
      setFormData(updatedData);
      setIsEditing(false);
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to update company profile");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    // Always create a NEW object so React sees a state change
    const resetData = JSON.parse(JSON.stringify(company));

    setFormData(resetData);
    setBusinessScore(resetData?.COMPANYSCORE?.BusinessScore || []);
    setFinancialScore(resetData?.COMPANYSCORE?.FinancialScore || []);
    setIsEditing(false);
  };

  const getTotalScore = (data) => {
    if (!data || !Array.isArray(data)) return 0;
    return data.reduce((sum, item) => {
      const score = parseFloat(item.SCORE);
      return !isNaN(score) ? sum + score : sum;
    }, 0);
  };

  // helper function for revenue formatting
  const getRevenueLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue > 100000000) {
      return "> than HK$ 100,000,000";
    } else if (revenue >= 20000000 && revenue <= 100000000) {
      return "Between HK$ 20,000,000 and HK$ 100,000,000";
    } else if (revenue >= 5000000 && revenue < 20000000) {
      return "Between HK$ 5,000,000 and HK$ 20,000,000";
    } else if (revenue < 5000000) {
      return "< than HK$ 5,000,000";
    }
    return "N/A";
  };

  const getRevenueLabelGrowth = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue > 20) {
      return "Revenue growth is > than 20%";
    } else if (revenue >= 0 && revenue <= 20) {
      return "Revenue growth between 0% and 20%";
    } else if (revenue < 0) {
      return "Revenue growth is < than 0%";
    }
    return "N/A";
  };

  const getThreeYearAvg = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue > 20) {
      return "Avg. gross margin is > than 20%";
    } else if (revenue >= 0 && revenue <= 20) {
      return "Avg. gross margin is between 0% and 20%";
    } else if (revenue < 0) {
      return "Avg. gross margin is < than 0%";
    }
    return "N/A";
  };

  const getCurrentRatioLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue > 1.5) {
      return "Current ratio is > 1.5";
    } else if (revenue >= 1.0 && revenue <= 1.5) {
      return "Current ratio is between 1.0 and 1.5";
    } else if (revenue < 1.0) {
      return "Current ratio is < 1.0";
    }
    return "N/A";
  };
  const getQuickRatioLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue > 1.5) {
      return "Current ratio is > 1.5";
    } else if (revenue >= 1 && revenue <= 1.5) {
      return "Current ratio is between 1.0 and 1.5";
    } else if (revenue < 1.0) {
      return "Current ratio is > 1.0";
    }
    return "N/A";
  };
  const getCashConversionCycleLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue >= 0.0 && revenue <= 45.0) {
      return "0 - 45 days";
    } else if (revenue >= 45.0 && revenue <= 90.0) {
      return "45 - 90 days";
    } else if (revenue > 90.0) {
      return "> 90days";
    }
    return "N/A";
  };
  const getCashFlowLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue > 0.0) {
      return "> 0";
    } else if (revenue < 0.0) {
      return "< 0";
    }
    return "N/A";
  };
  const getQualityAssetsLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue < 10.0) {
      return "< 10% of related parties assets";
    } else if (revenue >= 10.0 && revenue <= 20.0) {
      return "10% - 20% of related parties assets";
    } else if (revenue > 20.0) {
      return "> 20% of related parties assets";
    }
    return "N/A";
  };
  const getDebtAssetsRatioLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue < 0.6) {
      return "Debt to Assets ratio is < 0.6";
    } else if (revenue >= 0.6 && revenue <= 1.0) {
      return "Debt to Assets ratio is between 0.6 and 1.0";
    } else if (revenue > 1.0) {
      return "Debt to Assets ratio is > 1.0";
    }
    return "N/A";
  };
  const getNetLeverageRatioLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue < 0.0) {
      return "Net debt to EBITDA ratio is < 0 due to negative EBITDA";
    } else if (revenue < 5.0) {
      return "Net debt to EBITDA ratio is < 5.0";
    } else if (revenue >= 5.0 && revenue <= 8.0) {
      return "Net debt to EBITDA ratio is between 5.0 and 8.0";
    } else if (revenue > 8.0) {
      return "Net debt to EBITDA ratio is > 8.0";
    }

    return "N/A";
  };

  const getInterestCoverageRatioLabel = (revenue) => {
    if (revenue == null || revenue === "") return "N/A";

    if (revenue > 2.0) {
      return "Interest coverage ratio is > 2.0";
    } else if (revenue >= 1.5 && revenue <= 2.0) {
      return "Interest coverage ratio is between 1.5 and 2.0";
    } else if (revenue < 1.0) {
      return "Interest coverage ratio is < 1.0 ";
    }
    return "N/A";
  };

  // debtor assesment risk
  // DB
  const selectedData =
    selectedDB && selectedDB.find((item) => item.DandB_Score === selectedScore);

  const getCalculatedValue = () => {
    const num = Number(inputValue);
    if (isNaN(num)) return "-";

    if (num > 72) return 5;
    if (num <= 72 && num >= 63) return 10;
    if (num <= 62 && num >= 56) return 15;
    if (num <= 55 && num > 0) return 20;
    return "-"; // default case
  };

  const [weights, setWeights] = useState({
    col1: "65",
    col2: "25",
    col3: "10",
  });

  const handleWeightChange = (field, value) => {
    setWeights((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Function to calculate Weighted D&B values with % weights
  const getWeightedDBValues = () => {
    const risk = Number(selectedData?.risk) || 0;
    const col1 = Number(weights.col1) || 0;

    const calculated = Number(getCalculatedValue()) || 0;
    const col2 = Number(weights.col2) || 0;

    const finStrength = Number(selectedData?.fin_strength) || 0;
    const col3 = Number(weights.col3) || 0;

    return {
      weighted1: Math.round((risk * col1) / 100),
      weighted2: Math.round((calculated * col2) / 100),
      weighted3: Math.round((finStrength * col3) / 100),
    };
  };

  const weightedToScoreMap = {
    5: 100,
    6: 93,
    7: 85,
    8: 78,
    9: 70,
    10: 69,
    11: 62,
    12: 55,
    13: 47,
    14: 40,
    15: 39,
    16: 29,
    17: 20,
    18: 10,
    19: 0,
    20: -5,
  };

  const sumWeighted =
    Number(getWeightedDBValues().weighted1 || 0) +
    Number(getWeightedDBValues().weighted2 || 0) +
    Number(getWeightedDBValues().weighted3 || 0);

  const mappedScore = weightedToScoreMap[sumWeighted] ?? "-";

  // Handle select change for coface
  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedCoface(value);

    const found = cofaceOptions.find((opt) => opt.Coface === Number(value));
    setSelectedScoreCoface(found ? found.Riverchain_Score_Coface : "");
  };

  // Handle select change for SP
  const handleChangeSP = (e) => {
    const value = e.target.value;
    setSelectedSP(value);

    const found = spOptions.find((opt) => opt.SandP === value);

    if (found) {
      setSelectedScoreSP(
        found.Riverchain_Score_SandP ?? found["Riverchain_Score_SandP]"] ?? ""
      );
    } else {
      setSelectedScoreSP("");
    }
  };

  // Handle select change for Fitch
  const handleChangeFitch = (e) => {
    const value = e.target.value;
    setSelectedFitch(value);

    const found = fitchOptions.find((opt) => opt.Fitch === value);

    if (found) {
      setSelectedScoreFitch(
        found.Riverchain_Score_Fitch ?? found["Riverchain_Score_Fitch]"] ?? ""
      );
    } else {
      setSelectedScoreFitch("");
    }
  };

  // Handle select change for Moody
  const handleChangeMoody = (e) => {
    const value = e.target.value;
    setSelectedMoody(value);

    const found = moodyOptions.find((opt) => opt.Moody_s === value);

    if (found) {
      setSelectedScoreMoody(
        found.Riverchain_Score_Moody_s ??
          found["Riverchain_Score_Moody_s]"] ??
          ""
      );
    } else {
      setSelectedScoreMoody("");
    }
  };

  // litigation
  const handleChangeLitigation = (e) => {
    setSelectedOptionLitigation(e.target.value); // store the selected label
  };

  // Winding
  const handleChangeWinding = (e) => {
    setSelectedOptionWinding(e.target.value); // store the selected label
  };

  // Default rating
  const handleChangeDefault = (e) => {
    setSelectedDefault(e.target.value);
  };

  // Parent rating
  const handleChangeParent = (e) => {
    setSelectedParent(e.target.value);
  };

  // Final rating (Default takes priority, else Parent)
  // const finalRating = selectedDefault || selectedParent;

  // // Background color logic
  // const getBgColor = (rating) => {
  //   switch (rating) {
  //     case "A":
  //     case "B":
  //       return "lightgreen";
  //     case "C":
  //       return "yellow";
  //     case "D":
  //       return "red";
  //     default:
  //       return "transparent"; // no color if empty
  //   }
  // };

  // If no default or parent, calculate fallback score
  const litigationScore =
    selectedOptionLitigation && optionsLitigation[selectedOptionLitigation]
      ? optionsLitigation[selectedOptionLitigation]
      : 0;

  const windingScore =
    selectedOptionWinding && optionsWinding[selectedOptionWinding]
      ? optionsWinding[selectedOptionWinding]
      : 0;

  const spScore = Number(selectedScoreSP) || 0;

  const totalScore = spScore + litigationScore + windingScore;

  // Priority: Default > Parent > Computed
  let finalRating = "";

  // Priority: Default > Parent > Computed
  if (selectedDefault) {
    finalRating = selectedDefault;
  } else if (selectedParent) {
    finalRating = selectedParent;
  } else if (spScore !== 0 || litigationScore !== 0 || windingScore !== 0) {
    // Only calculate if at least one score exists
    if (totalScore >= 70 && totalScore <= 100) finalRating = "A";
    else if (totalScore >= 40 && totalScore <= 69) finalRating = "B";
    else if (totalScore >= 39 && totalScore <= 68) finalRating = "C";
    else if (totalScore >= 0 && totalScore <= 38) finalRating = "D";
  }

  // Background color logic
  const getBgColor = (rating) => {
    switch (rating) {
      case "A":
        return "#b3e1ba";
      case "B":
        return "#f9e5a4";
      case "C":
        return "#edb7b0";
      case "D":
        return "#ea3323";
      default:
        return "transparent";
    }
  };

  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <main className="content">
          <div className="row">
            <Navbar />
            <div className="col-md-10" style={{ marginTop: "30px" }}>
              <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
                Back to Company Log
              </NavLink>

              <br />
              <br />

              <NavLink
                to={`/details/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Company Information
              </NavLink>

              <NavLink
                to={`/DocumentCheckList/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Document Checklist
              </NavLink>

              <NavLink
                to={`/Searches/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Searches
              </NavLink>

              <NavLink
                to={`/FinancialAnalysis/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Financial Analysis
              </NavLink>

              <NavLink to={`/CompanyScore/${id}`} className="btn btn-dark ms-2">
                Company Score
              </NavLink>

              <NavLink
                to={`/ScoringCriteria/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Scoring Criteria
              </NavLink>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 style={{ marginTop: "15px" }}>
                  Company Score
                  <span
                    style={{
                      paddingLeft: "20px",
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    {company?.VersionString}
                  </span>
                </h3>
                <div>
                  {isEditing && (
                    <button
                      className="btn btn-secondary me-2"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  )}
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      isEditing ? handleSubmit() : setIsEditing(true)
                    }
                    disabled={isSubmitting}
                  >
                    {isEditing
                      ? isSubmitting
                        ? "Submitting..."
                        : "Submit"
                      : "Edit"}
                  </button>
                </div>
              </div>

              {loading ? (
                <ShimmerTable row={5} col={5} />
              ) : (
                <>
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td style={{ width: "50%" }}>Company Name:</td>
                        <td>{company?.COMPANYINFO?.COMPANYNAME_ENGLISH}</td>
                      </tr>
                      <tr>
                        <td>BR Number:</td>
                        <td
                          style={{
                            width: "50%",
                          }}
                        >
                          {company?.COMPANYINFO?.BUSINESSREGISTRATIONNUMBER}
                        </td>
                      </tr>
                      <tr>
                        <td>Date</td>
                        <td
                          style={{
                            width: "50%",
                          }}
                        ></td>
                      </tr>
                      <tr>
                        <td>Date Reviewed</td>
                        <td
                          style={{
                            width: "50%",
                          }}
                        ></td>
                      </tr>
                    </tbody>
                  </table>

                  <h5 style={{ fontWeight: "bold" }}>Business Score</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#173660",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        <th>Metric</th>
                        <th>Input</th>
                        <th>Score</th>
                        <th>Comments</th>
                        <th>Reviewer Check</th>
                      </tr>
                    </thead>
                    <tbody>
                      {businessScore
                        ?.filter(
                          (item) =>
                            item.METRIC?.toLowerCase() !==
                            "total business score"
                        )
                        .map((item, index) => (
                          <tr key={index}>
                            <td>{item.METRIC || "N/A"}</td>
                            <td>
                              {isEditing ? (
                                item.METRIC.toLowerCase() === "country risk" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                  </select>
                                ) : item.METRIC.toLowerCase() ===
                                  "industry risk" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Low cyclicality, moderate competitive risk">
                                      Low cyclicality, moderate competitive risk
                                    </option>
                                    <option value="Intermediate cyclicality, medium competitive risk">
                                      Intermediate cyclicality, medium
                                      competitive risk
                                    </option>
                                    <option value="High cyclicality, high competitive risk">
                                      High cyclicality, high competitive risk
                                    </option>
                                  </select>
                                ) : item.METRIC.toLowerCase() ===
                                  "years in operation" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="less than 3 years">
                                      less than 3 years
                                    </option>
                                    <option value="3 years to 7 years">
                                      3 years to 7 years
                                    </option>
                                    <option value="more than 7 years">
                                      more than 7 years
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "industry reputation / project track record" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    <option value="Positive industry reputation for standard of execution (for example ability to work on public works, HH subcon, etc.)">
                                      Positive industry reputation for standard
                                      of execution (for example ability to work
                                      on public works, HH subcon, etc.)
                                    </option>
                                    <option value="No information available from industry sources and advisors">
                                      No information available from industry
                                      sources and advisors
                                    </option>
                                    <option value="Negative industry reputation for standard of execution">
                                      Negative industry reputation for standard
                                      of execution
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "customer / project concentration" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Multiple ongoing projects (3 or more projects)">
                                      Multiple ongoing projects (3 or more
                                      projects)
                                    </option>
                                    <option value="Few ongoing projects">
                                      Few ongoing projects
                                    </option>
                                    <option value="No projects">
                                      No projects
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "winding-up petitions" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    <option value="No winding-up petitions">
                                      No winding-up petitions
                                    </option>
                                    <option value="Winding-up petitions that have been withdrawn (Past 3 years)">
                                      Winding-up petitions that have been
                                      withdrawn (Past 3 years)
                                    </option>
                                    <option value="Existing unsettled winding-up petition">
                                      Existing unsettled winding-up petition
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "material litigation" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="No material litigation">
                                      No material litigation
                                    </option>
                                    <option
                                      value="Material litigation that has been settled (Past 3
                            years)"
                                    >
                                      Material litigation that has been settled
                                      (Past 3 years)
                                    </option>
                                    <option value="Existing material litigation">
                                      Existing material litigation
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "ownership" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Resourced (i.e. part of a large parent or listed organization can access funding if needed)">
                                      Resourced (i.e. part of a large parent or
                                      listed organization can access funding if
                                      needed)
                                    </option>
                                    <option value="Under-resourced (i.e.no option for support or support unlikely)">
                                      Under-resourced (i.e.no option for support
                                      or support unlikely)
                                    </option>
                                    <option value="Distressed (i.e. owner is in financial difficulty, likely to borrow from the company)">
                                      Distressed (i.e. owner is in financial
                                      difficulty, likely to borrow from the
                                      company)
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "management ability" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Executive team with considerable industry experience">
                                      Executive team with considerable industry
                                      experience
                                    </option>
                                    <option value="Executive team with little industry experience">
                                      Executive team with little industry
                                      experience
                                    </option>
                                    <option value="Sole founder/owner with considerable industry experience">
                                      Sole founder/owner with considerable
                                      industry experience
                                    </option>
                                    <option value="Sole founder/owner with little industry experience">
                                      Sole founder/owner with little industry
                                      experience
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "administrative capacity" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Medium (meets expectations)">
                                      Medium (meets expectations)
                                    </option>
                                    <option value="High (displaying quick, accurate, and organized communication and reporting)">
                                      High (displaying quick, accurate, and
                                      organized communication and reporting)
                                    </option>
                                    <option value="Low (know instances of missing or inaccurate processes/information)">
                                      Low (know instances of missing or
                                      inaccurate processes/information)
                                    </option>
                                  </select>
                                ) : item.METRIC.trim().toLowerCase() ===
                                  "repayment track record of riverchain's loans" ? (
                                  <select
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Timely">Timely</option>
                                    <option value="N/A">N/A</option>
                                    <option value="Slight delay (< 3 business days from maturity date)">
                                      Slight delay (&lt; 3 business days from
                                      maturity date)
                                    </option>
                                    <option value="Significant delay (> 3 business days from maturity date)">
                                      Significant delay (&gt; 3 business days
                                      from maturity date)
                                    </option>
                                  </select>
                                ) : (
                                  <input
                                    className="form-control"
                                    value={item.INPUT}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "business",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  />
                                )
                              ) : (
                                item.INPUT
                              )}
                            </td>
                            <td>{item.SCORE ?? "N/A"}</td>
                            <td>
                              {isEditing ? (
                                <input
                                  className="form-control"
                                  value={item.COMMENTS || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "business",
                                      index,
                                      "COMMENTS",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                item.COMMENTS || "N/A"
                              )}
                            </td>
                            <td>
                              {isEditing ? (
                                <input
                                  className="form-control"
                                  value={item.REVIEWERCHECK || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "business",
                                      index,
                                      "REVIEWERCHECK",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                item.REVIEWERCHECK || "N/A"
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                    <tfoot>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td colSpan="2">Total Business Score</td>
                        <td colSpan="3">{getTotalScore(businessScore)}</td>
                      </tr>
                    </tfoot>
                  </table>

                  <h5 style={{ fontWeight: "bold" }}>Financial Score</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#173660",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        <th>Metric</th>
                        <th>Input</th>
                        <th>Score</th>
                        <th>Comments</th>
                        <th>Reviewer Check</th>
                      </tr>
                    </thead>
                    <tbody>
                      {financialScore
                        ?.filter(
                          (item) =>
                            item.METRIC?.toLowerCase() !==
                            "total financial score"
                        )
                        .map((item, index) => (
                          <tr key={index}>
                            <td>{item.METRIC || "N/A"}</td>
                            <td>
                              {isEditing ? (
                                //newly add only for liquidity current ratio edit mode
                                item.METRIC.toLowerCase().includes(
                                  "liquidity current ratio"
                                ) ? (
                                  <input
                                    className="form-control"
                                    value={getCurrentRatioLabel(
                                      latestCurrentRatio
                                    )}
                                    readOnly
                                  />
                                ) : item.METRIC.toLowerCase().includes(
                                    "qualified opinion from auditor"
                                  ) ? (
                                  <select
                                    className="form-control"
                                    value={
                                      item.INPUT === 0
                                        ? "unqualified"
                                        : item.INPUT === -20
                                        ? "qualified"
                                        : ""
                                    }
                                    onChange={(e) => {
                                      const selected = e.target.value;
                                      let value, score;

                                      if (selected === "unqualified") {
                                        value = 0;
                                        score = 0;
                                      } else if (selected === "qualified") {
                                        value = -20;
                                        score = -20;
                                      } else {
                                        value = "";
                                        score = null;
                                      }

                                      // Update INPUT
                                      handleInputChange(
                                        "financial",
                                        index,
                                        "INPUT",
                                        value
                                      );

                                      // Also update SCORE
                                      handleInputChange(
                                        "financial",
                                        index,
                                        "SCORE",
                                        score
                                      );
                                    }}
                                  >
                                    <option value="unqualified">
                                      Unqualified / N/A
                                    </option>
                                    <option value="qualified">Qualified</option>
                                  </select>
                                ) : item.METRIC.toLowerCase().includes(
                                    "known defaults"
                                  ) ? (
                                  <select
                                    className="form-control"
                                    value={
                                      item.INPUT === -30
                                        ? "yes"
                                        : item.INPUT === 0
                                        ? "no"
                                        : ""
                                    }
                                    onChange={(e) => {
                                      const selected = e.target.value;
                                      let value, score;

                                      if (selected === "yes") {
                                        value = -30;
                                        score = -30;
                                      } else if (selected === "no") {
                                        value = 0;
                                        score = 0;
                                      } else {
                                        value = "";
                                        score = null;
                                      }

                                      // Update INPUT
                                      handleInputChange(
                                        "financial",
                                        index,
                                        "INPUT",
                                        value
                                      );

                                      // Also update SCORE
                                      handleInputChange(
                                        "financial",
                                        index,
                                        "SCORE",
                                        score
                                      );
                                    }}
                                  >
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                  </select>
                                ) : (
                                  <input
                                    className="form-control"
                                    value={item.INPUT || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "financial",
                                        index,
                                        "INPUT",
                                        e.target.value
                                      )
                                    }
                                  />
                                )
                              ) : // item.INPUT ?? "N/A"
                              // newly changes
                              item.METRIC.trim().toLowerCase() ===
                                "revenue (latest financial year)" ? (
                                getRevenueLabel(latestRevenueValue)
                              ) : item.METRIC.toLowerCase().includes(
                                  "revenue growth"
                                ) ? (
                                getRevenueLabelGrowth(latestRevenueValueGrowth)
                              ) : item.METRIC.toLowerCase().includes(
                                  "gross profit"
                                ) ? (
                                getThreeYearAvg(avgThreeYearGPM)
                              ) : item.METRIC.toLowerCase().includes(
                                  "liquidity current ratio"
                                ) ? (
                                getCurrentRatioLabel(latestCurrentRatio)
                              ) : item.METRIC.toLowerCase().includes(
                                  "quick ratio"
                                ) ? (
                                getQuickRatioLabel(latestQuickRatio)
                              ) : item.METRIC.toLowerCase().includes(
                                  "cash conversion cycle"
                                ) ? (
                                getCashConversionCycleLabel(
                                  latestCashConversionCycle
                                )
                              ) : item.METRIC.toLowerCase().includes(
                                  "cashflow from operating"
                                ) ? (
                                getCashFlowLabel(latestCashFlow)
                              ) : item.METRIC.toLowerCase().includes(
                                  "quality of assets"
                                ) ? (
                                getQualityAssetsLabel(latestQualityAssets)
                              ) : item.METRIC.toLowerCase().includes(
                                  "debt to assets ratio"
                                ) ? (
                                getDebtAssetsRatioLabel(latestDebtAssetsRatio)
                              ) : item.METRIC.toLowerCase().includes(
                                  "net leverage ratio"
                                ) ? (
                                getNetLeverageRatioLabel(latestNetLeverageRatio)
                              ) : item.METRIC.toLowerCase().includes(
                                  "interest coverage"
                                ) ? (
                                getInterestCoverageRatioLabel(
                                  latestInterestCoverageRatio
                                )
                              ) : (
                                ""
                              )}
                            </td>

                            <td>{item.SCORE ?? "N/A"}</td>
                            <td>
                              {isEditing ? (
                                <input
                                  className="form-control"
                                  value={item.COMMENTS || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "financial",
                                      index,
                                      "COMMENTS",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                item.COMMENTS || "N/A"
                              )}
                            </td>
                            <td>
                              {isEditing ? (
                                <input
                                  className="form-control"
                                  value={item.REVIEWERCHECK || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "financial",
                                      index,
                                      "REVIEWERCHECK",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                item.REVIEWERCHECK || "N/A"
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                    <tfoot>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td colSpan="2">Total Financial Score</td>
                        <td colSpan="3">{getTotalScore(financialScore)}</td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td colSpan="2">Total raw Score</td>
                        <td colSpan="3">
                          {getTotalScore(financialScore) +
                            getTotalScore(businessScore)}
                        </td>
                      </tr>

                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td colSpan="2">Total Normalized Score</td>
                        <td colSpan="3"></td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          fontWeight: "bold",
                        }}
                      >
                        <td colSpan="2">
                          Riverchain Risk Category (Normalized)
                        </td>
                        <td colSpan="3">
                          {company?.COMPANYSCORE?.RIVERCHAINRISKCATEGORY}
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                  <h5 style={{ fontWeight: "bold" }}>Debtor Risk Assessment</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#173660",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        <th>Criteria</th>
                        <th>Input</th>
                        <th></th>
                        <th>Updated by Reviewer</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>D&B Score</td>
                        <td>
                          <select
                            className="form-select"
                            value={selectedScore}
                            onChange={(e) => setSelectedScore(e.target.value)}
                          >
                            <option value="">-- Select Score --</option>
                            {selectedDB &&
                              selectedDB
                                .slice() // make a copy so we don’t mutate state
                                .sort((a, b) =>
                                  a.DandB_Score.localeCompare(b.DandB_Score)
                                ) // ascending order
                                .map((item) => (
                                  <option
                                    key={item.DandB_Score}
                                    value={item.DandB_Score}
                                  >
                                    {item.DandB_Score}
                                  </option>
                                ))}
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>D&B Paydex</td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                          />
                        </td>
                        <td>Score between 1 and 100</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Max Credit Recco (HKD)</td>
                        <td></td>
                        <td>based on D&B</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td style={{ color: "#FF8C00" }}>
                          Riverchain Weighted Score [D&B]
                        </td>
                        <td style={{ color: "#FF8C00" }}>{mappedScore}</td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Coface Scoring</td>
                        <td>
                          <select
                            className="form-select"
                            value={selectedCoface}
                            onChange={handleChange}
                          >
                            <option value="">-- Select Coface --</option>
                            {cofaceOptions
                              .slice() // copy array to avoid mutating original
                              .sort((a, b) => a.Coface - b.Coface) // ascending order
                              .map((opt) => (
                                <option key={opt.Coface} value={opt.Coface}>
                                  {opt.Coface}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td style={{ color: "#FF8C00" }}>
                          Riverchain Score [Coface]
                        </td>
                        <td style={{ color: "#FF8C00" }}>
                          {selectedScoreCoface}
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>S&P Rating</td>
                        <td>
                          <select
                            className="form-select"
                            value={selectedSP}
                            onChange={handleChangeSP}
                          >
                            <option value="">-- Select S&amp;P --</option>
                            {spOptions
                              .slice()
                              .sort((a, b) => a.SandP.localeCompare(b.SandP))
                              .map((opt) => (
                                <option key={opt.SandP} value={opt.SandP}>
                                  {opt.SandP}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Fitch Rating</td>
                        <td>
                          <select
                            className="form-select"
                            value={selectedFitch}
                            onChange={handleChangeFitch}
                          >
                            <option value="">-- Select Fitch --</option>
                            {fitchOptions
                              .slice()
                              .sort((a, b) => a.Fitch.localeCompare(b.Fitch))
                              .map((opt) => (
                                <option key={opt.Fitch} value={opt.Fitch}>
                                  {opt.Fitch}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Moody's Rating</td>
                        <td>
                          <select
                            className="form-select"
                            value={selectedMoody}
                            onChange={handleChangeMoody}
                          >
                            <option value="">-- Select Moody --</option>
                            {moodyOptions
                              .slice()
                              .sort((a, b) =>
                                a.Moody_s.localeCompare(b.Moody_s)
                              )
                              .map((opt) => (
                                <option key={opt.Moody_s} value={opt.Moody_s}>
                                  {opt.Moody_s}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td style={{ color: "#FF8C00" }}>
                          Riverchain Score - before adjustments
                        </td>
                        <td style={{ color: "#FF8C00" }}>{selectedScoreSP}</td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Parent Co Rating (if applicable)</td>
                        <td>
                          <select
                            className="form-select"
                            value={selectedParent}
                            onChange={handleChangeParent}
                          >
                            <option value="">-- Select --</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Default Rating (if applicable)</td>
                        <td>
                          <select
                            className="form-select"
                            value={selectedDefault}
                            onChange={handleChangeDefault}
                          >
                            <option value="">-- Select --</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Winding-up Petitions</td>
                        <td>
                          <select
                            value={selectedOptionWinding}
                            onChange={handleChangeWinding}
                            className="form-control"
                          >
                            <option value="">-- Select --</option>
                            {Object.keys(optionsWinding).map((label) => (
                              <option key={label} value={label}>
                                {label}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Material Litigation</td>
                        <td>
                          <select
                            value={selectedOptionLitigation}
                            onChange={handleChangeLitigation}
                            className="form-control"
                          >
                            <option value="">-- Select --</option>
                            {Object.keys(optionsLitigation).map((label) => (
                              <option key={label} value={label}>
                                {label}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td style={{ color: "#FF8C00" }}>
                          Riverchain Score - after adjustments
                        </td>
                        <td style={{ color: "#FF8C00" }}>
                          {(() => {
                            // Get Litigation score
                            const litigationScore =
                              selectedOptionLitigation &&
                              optionsLitigation[selectedOptionLitigation]
                                ? optionsLitigation[selectedOptionLitigation]
                                : 0;

                            // Get Winding score
                            const windingScore =
                              selectedOptionWinding &&
                              optionsWinding[selectedOptionWinding]
                                ? optionsWinding[selectedOptionWinding]
                                : 0;

                            // Ensure SP score is numeric
                            const spScore = Number(selectedScoreSP) || 0;

                            // Sum all three
                            return spScore + litigationScore + windingScore;
                          })()}
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "bold" }}>
                          Riverchain Rating - Final
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            backgroundColor: getBgColor(finalRating),
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          {finalRating || "--"}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div>
                    <h5 style={{ fontWeight: "normal" }}>
                      Riverchain Weighted Score [D&B] Calculator
                    </h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr
                          style={{
                            backgroundColor: "#173660",
                            color: "#fff",
                            textAlign: "center",
                          }}
                        >
                          <th></th>
                          <th>D&B Risk Level</th>
                          <th>D&B Paydex</th>
                          <th>D&B Financial Strength</th>
                          <th>Output Score (Total)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>
                          <td>{selectedData?.risk}</td>
                          <td style={{ textAlign: "center" }}>
                            {getCalculatedValue()}
                          </td>
                          <td>{selectedData?.fin_strength}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Weight</td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={weights.col1}
                              onChange={(e) =>
                                handleWeightChange("col1", e.target.value)
                              }
                            />
                            %
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={weights.col2}
                              onChange={(e) =>
                                handleWeightChange("col2", e.target.value)
                              }
                            />
                            %
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={weights.col3}
                              onChange={(e) =>
                                handleWeightChange("col3", e.target.value)
                              }
                            />
                            %
                          </td>
                          <td>
                            {(Number(weights.col1 || 0) +
                              Number(weights.col2 || 0) +
                              Number(weights.col3 || 0)) /
                              100}
                          </td>
                        </tr>
                        <tr>
                          <td>Weighted D&B</td>
                          <td>{getWeightedDBValues().weighted1}</td>
                          <td style={{ textAlign: "center" }}>
                            {getWeightedDBValues().weighted2}
                          </td>
                          <td>{getWeightedDBValues().weighted3}</td>
                          <td>
                            {Number(getWeightedDBValues().weighted1 || 0) +
                              Number(getWeightedDBValues().weighted2 || 0) +
                              Number(getWeightedDBValues().weighted3 || 0)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
